import React, { FunctionComponent } from 'react';
import { ColumnInstance } from 'react-table';
import TableFilter from '../../TableFilter';
import { SortType } from '../../../common/enums/SortType';
import CustomPopover from '../../CustomPopover';
import Icon from '../../Icon';
import styles from './styles.module.scss';

interface IProps {
  className?: string;
  column: ColumnInstance;
  sortingEnabled: boolean;
  filteringEnabled: boolean;
}

const HeaderCell: FunctionComponent<IProps> = ({ className, column, sortingEnabled, filteringEnabled }) => {
  const sortColumn = () => {
    if (!sortingEnabled || !column.canSort) {
      return;
    }
    column.toggleSortBy(!column.isSortedDesc, true);
  };

  const filterIcon = () => (
    <CustomPopover
      rootClose
      trigger={<Icon icon="filter" />}
      popoverClassName={styles.filtersPopup}
    >
      <TableFilter
        onSort={sortColumn}
        onFilter={val => column.setFilter(val)}
        sortType={column.sortType as SortType}
        filterValue={column.filterValue || ''}
      />
    </CustomPopover>
  );

  return (
    <div
      role="presentation"
      {...column.getHeaderProps()}
      className={`hr-table-th ${className} ${sortingEnabled || filteringEnabled ? styles.hover : ''}`}
      onClick={sortColumn}
    >
      <span className={`${styles.label} ${column.isSorted ? styles.sorted : ''}`}>
        {column.render('Header')}
      </span>
      {column.isSorted && (
        <div className={styles.sortIcon}>
          <Icon className={`${column.isSortedDesc ? styles.secondaryIcon : ''} ${styles.sortAsc}`} icon="sort" />
          <Icon className={column.isSortedDesc ? '' : styles.secondaryIcon} icon="sort" />
        </div>
      )}
      {filteringEnabled && (
        <span
          role="presentation"
          onClick={e => e.stopPropagation()}
          className={`${styles.filterIcon} ${column.filterValue ? styles.visible : ''}`}
        >
          {filterIcon()}
        </span>
      )}
    </div>
  );
};

export default HeaderCell;
